import { Injectable } from '@angular/core';
import { DomainEventBus, DomainEvent, DomainEventType } from '../events/domain-event-bus';
import { filter } from 'rxjs/operators';
import { metrics, trace } from '@opentelemetry/api';
import { logs, SeverityNumber } from '@opentelemetry/api-logs';
import { OTEL_SERVICE_NAME } from './telemetry.constants';

@Injectable({ providedIn: 'root' })
export class ErrorPageTelemetryService {
  private meter = metrics.getMeter(OTEL_SERVICE_NAME);
  private tracer = trace.getTracer(OTEL_SERVICE_NAME);
  private logger = logs.getLogger(OTEL_SERVICE_NAME);
  private errorPageShown = this.meter.createCounter('ui_error_page_shown_total', {
    description: 'Total times the error page was shown'
  });

  constructor(bus: DomainEventBus) {
    bus.events$.pipe(filter((e) => e.type === DomainEventType.ErrorPageShown)).subscribe((e) => {
      const ev = e as Extract<DomainEvent, { type: typeof DomainEventType.ErrorPageShown }>;
      this.errorPageShown.add(1);

      this.tracer.startActiveSpan('ui.error.page', (span) => {
        try {
          span.setAttribute('session.id', ev.sessionId);
        } catch {}
        if (ev.publicId) span.setAttribute('payment.public_id', ev.publicId);
        if (ev.status) span.setAttribute('status', ev.status);
        if (ev.url) span.setAttribute('url', ev.url);

        const spanContext = span.spanContext();
        const traceId = spanContext.traceId;
        const spanId = spanContext.spanId;

        this.logger.emit({
          body: 'UI error page shown',
          severityNumber: SeverityNumber.WARN,
          severityText: 'WARN',
          attributes: {
            'session.id': ev.sessionId,
            'payment.public_id': ev.publicId,
            status: ev.status,
            url: ev.url,
            'trace.id': traceId,
            'span.id': spanId
          }
        });

        span.end();
      });
    });
  }
}
